import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';

import { filter, map, startWith } from 'rxjs';

import { CommandFailureService } from '@core/services/command-failure.service';

import { LeaveConfirmDialog } from '@shared/components/leave-confirm-dialog/leave-confirm-dialog';
import { Nav } from '@shared/components/nav/nav';
import { PageForbiddenNotice } from '@shared/components/page-forbidden-notice/page-forbidden-notice';
import { SessionRevokedDialog } from '@shared/components/session-revoked-dialog/session-revoked-dialog';
import { StatusBar } from '@shared/components/status-bar/status-bar';
import { ToastHost } from '@shared/components/toast-host/toast-host';

// Routes that render outside the authenticated app shell — no sidebar (the callback screen
// is a bare spinner, and a denied/unauthenticated visitor hasn't earned a nav yet).
const ROUTES_WITHOUT_NAV = ['/auth/callback', '/access-denied'];

@Component({
  imports: [RouterOutlet, Nav, SessionRevokedDialog, LeaveConfirmDialog, PageForbiddenNotice, StatusBar, ToastHost],
  selector: 'app-root',
  styleUrl: './app.scss',
  templateUrl: './app.html',
})
export class App {
  private readonly router = inject(Router);

  constructor() {
    // Listens for CommandFailedEvent from the start, whatever page is open (it says why a change did not happen).
    inject(CommandFailureService);
  }

  protected readonly showNav = toSignal(
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      map((event) => !ROUTES_WITHOUT_NAV.some((route) => event.urlAfterRedirects.startsWith(route))),
      startWith(!ROUTES_WITHOUT_NAV.some((route) => this.router.url.startsWith(route))),
    ),
    { initialValue: true },
  );
}
